var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 497 497",
    height: 512,
    viewBox: "0 0 497 497",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m472 80v77h-447v-77c0-11.51 6.48-21.51 16-26.53 4.18-2.22 8.94-3.47 14-3.47h387c11.51 0 21.51 6.48 26.53 16 2.22 4.18 3.47 8.94 3.47 14z",
    fill: "#fd646f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m145 50v56c0 5.52-4.48 10-10 10h-46c-5.52 0-10-4.48-10-10v-56z",
    fill: "#fc4755"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m402 50v56c0 5.52-4.48 10-10 10h-46c-5.52 0-10-4.48-10-10v-56z",
    fill: "#fc4755"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m41 53.47v103.53h-16v-77c0-11.51 6.48-21.51 16-26.53z",
    fill: "#fc4755"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#e6e6e6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m107 216.82h51.45c2.761 0 5 2.239 5 5v51.45c0 2.761-2.239 5-5 5h-51.45c-2.761 0-5-2.239-5-5v-51.45c0-2.761 2.239-5 5-5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m107 293.27h51.45c2.761 0 5 2.239 5 5v51.46c0 2.761-2.239 5-5 5h-51.45c-2.761 0-5-2.239-5-5v-51.46c0-2.761 2.239-5 5-5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m107 369.73h51.45c2.761 0 5 2.239 5 5v51.45c0 2.761-2.239 5-5 5h-51.45c-2.761 0-5-2.239-5-5v-51.45c0-2.761 2.239-5 5-5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m183.45 216.82h52.55c2.761 0 5 2.239 5 5v51.45c0 2.761-2.239 5-5 5h-52.55c-2.761 0-5-2.239-5-5v-51.45c0-2.761 2.239-5 5-5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m183.45 293.27h52.55c2.761 0 5 2.239 5 5v51.46c0 2.761-2.239 5-5 5h-52.55c-2.761 0-5-2.239-5-5v-51.46c0-2.761 2.239-5 5-5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m183.45 369.73h52.55c2.761 0 5 2.239 5 5v51.45c0 2.761-2.239 5-5 5h-52.55c-2.761 0-5-2.239-5-5v-51.45c0-2.761 2.239-5 5-5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m261 216.82h52.55c2.761 0 5 2.239 5 5v51.45c0 2.761-2.239 5-5 5h-52.55c-2.761 0-5-2.239-5-5v-51.45c0-2.761 2.239-5 5-5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m261 293.27h52.55c2.761 0 5 2.239 5 5v51.46c0 2.761-2.239 5-5 5h-52.55c-2.761 0-5-2.239-5-5v-51.46c0-2.761 2.239-5 5-5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m261 369.73h52.55c2.761 0 5 2.239 5 5v51.45c0 2.761-2.239 5-5 5h-52.55c-2.761 0-5-2.239-5-5v-51.45c0-2.761 2.239-5 5-5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m395 221.82v51.45c0 2.761-2.239 5-5 5h-51.45c-2.761 0-5-2.239-5-5v-51.45c0-2.761 2.239-5 5-5h51.45c2.761 0 5 2.239 5 5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m338.55 293.27h51.45c2.761 0 5 2.239 5 5v51.46c0 2.761-2.239 5-5 5h-51.45c-2.761 0-5-2.239-5-5v-51.46c0-2.761 2.239-5 5-5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m338.55 369.73h51.45c2.761 0 5 2.239 5 5v51.45c0 2.761-2.239 5-5 5h-51.45c-2.761 0-5-2.239-5-5v-51.45c0-2.761 2.239-5 5-5z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m25 150v317c0 16.57 13.43 30 30 30h387c16.57 0 30-13.43 30-30v-317z",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m145 10v80c0 5.52-4.48 10-10 10h-30c-5.52 0-10-4.48-10-10v-80c0-5.52 4.48-10 10-10h30c5.52 0 10 4.48 10 10z",
    fill: "#50758d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m102 216.82h61.45v61.45h-61.45z",
    fill: "#ffac5c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m333.55 216.82h61.45v61.45h-61.45z",
    fill: "#ffac5c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m178.45 216.82h62.55v61.45h-62.55z",
    fill: "#ffac5c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m102 293.27h61.45v61.46h-61.45z",
    fill: "#ffac5c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m333.55 293.27h61.45v61.46h-61.45z",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m178.45 293.27h62.55v61.46h-62.55z",
    fill: "#ffac5c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m102 369.73h61.45v61.45h-61.45z",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m333.55 369.73h61.45v61.45h-61.45z",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m178.45 369.73h62.55v61.45h-62.55z",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m256 216.82h62.55v61.45h-62.55z",
    fill: "#ffac5c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m256 293.27h62.55v61.46h-62.55z",
    fill: "#ffac5c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m256 369.73h62.55v61.45h-62.55z",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m402 10v80c0 5.52-4.48 10-10 10h-30c-5.52 0-10-4.48-10-10v-80c0-5.52 4.48-10 10-10h30c5.52 0 10 4.48 10 10z",
    fill: "#50758d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m25 150v317c0 16.57 13.43 30 30 30h11.08c-13.99-2.54-24.58-14.78-24.58-29.5v-296.28c1.13-3.05 4.06-5.22 7.5-5.22h423v-15.5-.5z",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m121 100h-16c-5.52 0-10-4.48-10-10v-80c0-5.52 4.48-10 10-10h6v90c0 5.52 4.48 10 10 10z",
    fill: "#2b597f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m378 100h-16c-5.52 0-10-4.48-10-10v-80c0-5.52 4.48-10 10-10h6v90c0 5.52 4.48 10 10 10z",
    fill: "#2b597f"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.f4a344ed.svg";
export { ForwardRef as ReactComponent };